import { getDicList } from '@/config/tool';

// 搜索重置  分页回调
export const myMixin = {
  async created() {
    if (this.dicArr) {
      await Promise.all(this.dicArr.filter(item => !this.dicMap[item]).map(item => getDicList(item)));
    }
    this.init && this.init();
  },
  methods: {
    // 筛选查询
    normalSearch(obj) {
      this.initParam = obj;
      this.queryData();
    },
    // 筛选重置
    normalResetQuery() {
      for (const key in this.initParam.param) {
        this.initParam.param[key] = '';
      }
      this.queryData(false);
    },
    // 页数改变
    handleCurrentChange(val) {
      this.initParam.pageNum = val;
      this.queryData(false);
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.initParam.pageNum = 1;
      this.initParam.pageSize = val;
      this.queryData();
    },
  },
  computed: {
    dicMap() {
      return this.$store.getters['getDicMap'];
    },
  },
};
